<template>
  <div id="public">
    <!-- 公開繳款項目內容 -->
    <div
      id="div_public"
      class="tab-pane fade show"
      role="tabpanel"
    >
      <div class="col-12 pt-3 table-style">
        <!-- 元件-標題 -->
        <v-title>
          <v-font
            font-css="title-age"
            font-text="步驟一：選擇收費項目"
          />
          <div class="spanfs mt-2">
            <v-font
              slot="etext"
              font-text="Step One: Choose Fee Item"
            />
          </div>
        </v-title>
        <!-- 第一層 篩選 -->
        <div class="form-group row">
          <v-label
            class="lh-fs ml-3"
            for="input-query"
            LabText="篩選資料："
            Labbold="true"
          >
            <v-font
              slot="small"
              font-css="spanfs"
              font-text="Keyword for Search"
            />
          </v-label>
          <div class="col-md-5">
            <input
              id="input-query"
              class="input-style"
              type="text"
              placeholder="請輸入關鍵字"
              v-model="filter"
            >
          </div>
        </div>
        <!-- 第二層 查詢單位 -->
        <div class="form-group row">
          <!-- 查詢單位 -->
          <v-label
            for="DeptID"
            class="lh-fs ml-3 mr-4"
            style="padding-right: 1.47rem !important;"
            LabText="查詢單位："
            Labbold="true"
          >
            <v-font
              slot="small"
              font-css="spanfs"
              font-text="Department"
            />
          </v-label>
          <div class="col-md-3 input-group">
            <v-Dept @SelectDept="SelectDept" />
          </div>
        </div>
        <!-- 第三層 筆數 -->
        <div class="form-group row">
          <!-- 筆數 -->
          <v-label
            class="lh-fs ml-3"
            for="Page-select"
            style="padding-right: 1.9rem !important;"
            LabText="筆數："
            Labbold="true"
          >
            <v-font
              slot="small"
              font-css="spanfs"
              font-text="Items per Page"
            />
          </v-label>
          <div class="col-md-3">
            <!-- 元件-筆數 -->
            <v-page @RecPerPage="RecPerPage" />
          </div>
        </div>
        <hr>
        <v-font
          font-css="small-color"
          font-text="*加入購物車前，請確認有相同繳費通路"
        />
        <!-- 表格資料 -->
        <template>
          <b-table
            id="public-table"
            hover
            small
            bordered
            show-empty
            stacked="md"
            empty-text="目前無資料"
            empty-filtered-text="查無資料"
            :items="items"
            :filter="filter"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            @filtered="onFiltered"
          >
            <!-- 收費項目編號 -->
            <template v-slot:cell(FeeItemId)="data">
              {{ Size(data.item.FeeItemId) }}
            </template>
            <!-- 單位 -->
            <template v-slot:cell(ApplyDeptName)="data">
              {{ data.item.ApplyDeptName }}
            </template>
            <!-- 金額 -->
            <template v-slot:cell(FeeItemValue)="data">
              {{ data.item.FeeItemValue + ' 元' }}
            </template>
            <!-- 數量加減 -->
            <template v-slot:cell(FeeItemCount)="data">
              <input
                class="qtyminus catleft"
                type="button"
                value="-"
                v-on:click="DownCount(data)"
              >
              <input
                class="qty"
                name="quantity"
                type='tel'
                onkeyup="value=value.replace(/[^\d]/g,'')"
                v-model.number="data.item.FeeItemCount"
              >
              <input
                class="qtyminus catright"
                type="button"
                value="+"
                v-on:click="AddCount(data)"
              >
            </template>
            <!-- 繳費截止日 -->
            <template v-slot:cell(PayDateEnd)="data">
              {{ data.item.PayDateEnd }}
            </template>
            <!-- 加入購物車 -->
            <template v-slot:cell(Actions)="data">
              <v-button
                class="lh-fs"
                title="加入"
                btn-text="加入"
                btn-type="primary"
                @click.native="PostAddCart(data.item)"
              >
                <br slot="eg" />
                <v-font
                  slot="icon"
                  font-css="spanfss"
                  font-text="Add"
                />
              </v-button>
            </template>
          </b-table>
          <!-- 分頁 -->
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            class="my-0 mb-2"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import { apiFeeorderQuerypublic, apiFeeorderShopadd } from '../../../Api/api'
import { fillcompile } from '../../../Api/compile'
export default {
  data () {
    return {
      items: [], // 公開項目資料
      fields: [ // 公開項目標題 fields，sortable可排序、sortDirection排序方式
        { key: 'SerialNo', label: '#', thClass: 'table-th', sortDirection: 'desc', sortable: true },
        { key: 'FeeItemId', label: '收費項目編號\nFee Item Id', thClass: 'table-th' },
        { key: 'ApplyDeptName', label: '單位\nDepartment', thClass: 'table-th', sortable: true },
        { key: 'FeeItemName', label: '收費項目名稱\nFee Item Name', thClass: 'table-th', class: 'word-bold', variant: 'warning' },
        { key: 'FeeItemValue', label: '金額\nAmount', thClass: 'table-th', variant: 'warning', sortable: true },
        { key: 'PayCategory', label: '繳費通路\nPayment Method', thClass: 'table-th', class: 'table-during', sortable: true },
        { key: 'FeeItemCount', label: '數量\nQuantity', thClass: 'table-th', class: 'table-durings' },
        { key: 'PayDateEnd', label: '繳費截止日\nPayment Deadline', thClass: 'table-th', class: 'table-nine', sortable: true },
        { key: 'Actions', label: '功能\nAction', thClass: 'table-th' }
      ],
      FeeItem: {
        FeeItemId: '',
        FeeOrderId: '',
        FeeItemType: null,
        FeeItemCount: null,
        FeeItemValue: null
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 10, // 起始筆數數量
      value: null,
      filter: null,
      ApplyDeptId: ''
    }
  },
  computed: {
    sortOptions () {
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  created () {
    this.PostQueryPublic()
  },
  watch: {
    // 當 form 裡面的 type 改變時則會觸發
    'ApplyDeptId' () {
      this.PostQueryPublic()
    }
  },
  methods: {
    SelectDept (vDeptId) { // 元件-部門
      this.ApplyDeptId = vDeptId
    },
    RecPerPage (SublayerPage) { // 元件-筆數
      this.perPage = SublayerPage
    },
    Size (data) { // 手機版字數超過12換行
      const datas = data.replace(/(.{12})/g, '$1\n')
      return datas
    },
    onFiltered (filteredItems) {
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    AddCount (data) { // 數量加，不得大於50
      if (data.item.FeeItemCount >= 50) {
        data.item.FeeItemCount = 50
      } else {
        data.item.FeeItemCount++
      }
    },
    DownCount (data) { // 數量減，不得小於0
      if (data.item.FeeItemCount <= 0) {
        data.item.FeeItemCount = 0
      } else {
        data.item.FeeItemCount -= 1
      }
    },
    CountZero () { // 數量歸零
      for (let i = 0; i < this.items.length; i++) {
        const json = this.items[i]
        json.FeeItemCount = 0
      }
    },
    PostQueryPublic () { // 查詢公開 F_API 006
      // 定義資料
      const vm = this
      const NewData = JSON.parse(localStorage.getItem('M_Identity'))
      vm.$bus.$emit('Cart', 'true')
      if (vm.ApplyDeptId) {
        NewData.ApplyDeptId = vm.ApplyDeptId.DeptId
      } else {
        NewData.ApplyDeptId = ''
      }
      // 呼叫API
      apiFeeorderQuerypublic(NewData).then(
        res => {
          if (res !== undefined) {
            for (let i = 0; i < res.Data.length; i++) { // 遍歷GET data
              const json = res.Data[i] // 添增Count屬性
              json.FeeItemCount = '0'
              json.SerialNo = i + 1
              json.PayCategory = fillcompile(json.PayCategory)
            }
            vm.items = res.Data
            vm.totalRows = vm.items.length
          } else {
            vm.ApplyDeptId = ''
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostAddCart (data) { // 加入購物車 F_API 009
      // 判斷數量
      const vm = this
      if (data.FeeItemCount === '0' || data.FeeItemCount === null || data.FeeItemCount === 0) {
        vm.$bus.$emit('Modals', '數量不得為0')
        $('#CheckError').modal('show')
      } else {
        // 定義資料
        vm.FeeItem.FeeItemId = data.FeeItemId
        vm.FeeItem.FeeItemType = data.FeeItemType
        vm.FeeItem.FeeItemCount = data.FeeItemCount
        vm.FeeItem.FeeItemValue = data.FeeItemValue
        const NewData = Object.assign(JSON.parse(localStorage.getItem('M_Identity')), vm.FeeItem)
        // 呼叫API
        apiFeeorderShopadd(NewData).then(
          res => {
            if (res !== undefined) {
              vm.CountZero()
              vm.$bus.$emit('Cart', 'true') // 發送購物車數量訊息
              vm.$bus.$emit('messsage:push', '已加入購物車', 'primary')
              vm.FeeItem.FeeItemId = ''
              vm.FeeItem.FeeItemType = null
              vm.FeeItem.FeeItemCount = null
              vm.FeeItem.FeeItemValue = null
              vm.FeeItem.FeeOrderId = ''
            }
          }
        )
      }
    }
  }
}
</script>

<style lang="scss">
// 加減鈕 中css
.qty {
  width: 50px;
  height: 40px;
  text-align: center;
  border: 0px;
  border-top: 0.8px solid #aaa;
  border-bottom: 1px solid #aaa;
}
// 加減鈕 左右css
input.qtyminus {
  width: 25px;
  height: 40px;
  border: 1px solid #aaa;
  background: #f8f8f8;
}
// 加減鈕 左css
.catleft {
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
// 加減鈕 右css
.catright {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}
@media only screen and (max-width:767px) {
  .qty {
    height: 39.8px;
  }
}
</style>
